import Row from '@components/Row';
import Text from '@components/Text';
import TextUnderline from '@components/TextUnderline';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import usePriceUnit from '@hooks/item/usePriceUnit';
import { UserCouponResponse } from '@models/coupon';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    coupon: UserCouponResponse;
}

function CouponText({ coupon }:Props) {
    const { t } = useTranslation('coupon');
    const {
        availableShops,
        couponName,
        discountMethod,
        discountValue,
    } = coupon;
    const priceUnit = usePriceUnit();
    return (
        <Fragment>
            {availableShops !== '전체매장' && (
                <TextUnderline>
                    <Text size='xl' fontWeight='bold' color={colors.gray6}>
                        {availableShops === 'ALL_SHOPS' ? t('detail.allShops') : availableShops}
                    </Text>
                </TextUnderline>
            )}
            <NameText
                fontWeight='bold'
                color={colors.gray8}
                size='3xl'
                align='center'>
                {couponName}
            </NameText>
            {discountMethod !== 'BOGO' && (
                <Row spacing={8}>
                    <Text size='xl' fontWeight='bold' color={colors.red} >
                        {discountValue.toLocaleString()}{discountMethod === 'RATE' ? '%' : priceUnit}
                    </Text>
                </Row>
            )}
        </Fragment>
    );
}

const NameText = styled(Text)`
    font-size: 24px !important;
    line-height: 36px !important;
    margin-bottom: 6px;
`;

export default CouponText;
